import { useContext, useState, useEffect } from "react";
import {Link as RouterLink, useParams} from "react-router-dom";

import {
  Card,
  Container,
  Menu,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";

import Page from "../../../components/Page";
import Scrollbar from "../../../components/Scrollbar";
import HeaderBreadcrumbs from "../../../components/HeaderBreadcrumbs";
import CreditChargeDialog from "../../../components/CreditChargeDialog";
import TicketCreateDialog from "../../../components/TicketCreateDialog";
import {
  ManageInvestorListToolbar,
} from "../../../sections/@dashboard/manage-investor";

import { PATH_DASHBOARD } from "../../../routes/paths";

import InvestorContext from "../../../contexts/investor/InvestorContext";

import TicketContext from "../../../contexts/ticket/TicketContext";
import { createTicket } from "../../../contexts/ticket/TicketActions";
import TicketType from "../../../contexts/ticket/TicketType";

import { fDate, fDateTime } from "../../../utils/formatTime";
import { defaultLabelDisplayedRows } from "src/utils/pagination";
import { descendingComparator, applySortFilter, getComparator } from "../../../utils/sort";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { faIR } from "@mui/x-data-grid/locales";
import axios from "../../../axios";

export default function CommentList() {
  const [page, setPage] = useState(0);
  const [filterName, setFilterName] = useState("");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [openCredit, setOpenCredit] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [investorId, setInvestorId] = useState("");
  const [openActionButton, setOpenActionButton] = useState(false);
  const [openTicket, setOpenTicket] = useState(false);
  const [comments, setComments] = useState([]);
  const [startupName, setStartupName] = useState('');
  const { id } = useParams()
  const {
    fetchInvestors,
    fetchReceiptInvoices,
    creditCharge,
    creditReject,
    investors,
    invoices,
    loading,
  } = useContext(InvestorContext);
  const { dispatch } = useContext(TicketContext);

  useEffect(() => {
    axios.get(`/v1/startups/comments-startup/${id}`).then(res => {
      setStartupName(res.data.data.name)
      setComments(res.data.data.comments)
    })
  }, []);

  const handleClick = (event, id) => {
    setOpenActionButton(event.currentTarget);
    setInvestorId(id);
  };

  const handleClose = () => {
    setOpenActionButton(false);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const showInvestorStatus = (status) => {
    switch (status) {
      case "REGISTER":
        return "تایید نشده";
      case "PENDING":
        return "در حال انجام";
      case "COMPLETE_INFORMATION":
        return "تکمیل اطلاعات";
      case "COMPLETED":
        return "تایید شده";
      case "REJECTED":
        return "رد شده";
      case "SUSPENDED":
        return "معلق";
    }
  };

  const handleOpenCredit = (investorId) => {
    setOpenCredit(true);
    fetchReceiptInvoices(investorId);
    handleClose();
  };

  const handleCloseCredit = () => {
    setOpenCredit(false);
    setInvestorId("");
  };

  const handleSubmitCredit = async (values) => {
    values.investor = investorId;
    if (values.status === "ACCEPTED") {
      creditCharge(values);
    } else {
      creditReject(values);
    }

    handleCloseCredit();
  };

  const handleOpenTicket = () => {
    setOpenTicket(true);
  };

  const handleCloseTicket = () => {
    setOpenTicket(false);
    setInvestorId("");
  };

  const handleSubmitTicket = async (values) => {
    try {
      values.investorId = investorId;
      const ticketData = await createTicket(values);
      dispatch({ type: TicketType.CREATE_TICKET, payload: ticketData });
      handleCloseTicket();
      handleClose();
    } catch (e) {
      console.log(e);
    }
  };
  const columns = [
    {
      field: "id",
      headerName: "ردیف",
      width: 50,
      editable: false,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.row._id) + 1,
    },

    {
      field: "fullName",
      headerName: "نام سرمایه گذار",
      type: "string",
      width: 200,
      valueGetter: (value, row) => `${row?.userId?.firstName || ""} ${row?.userId?.lastName || ""}`,
    },
    {
      field: "description",
      headerName: "نظر",
      type: "string",
      width: 300,
      valueGetter: (value, row) => row.description,
    },

    {
      field: "startup",
      headerName: "نام طرح",
      type: "string",
      width: 300,
      valueGetter: (value, row) => startupName,
    },
    // {
    //   field: "action",
    //   headerName: "درخواست های سرمایه گذاری",
    //   width: 210,
    //   type: "actions",
    //   getActions: (params) => [
    //     // <GridActionsCellItem
    //     //   icon={<List />}
    //     //   label="Duplicate User"
    //     //   to={`/dashboard/manage-investor/request-invest/${params.row._id}`}
    //     //   onClick={handleClose}
    //     //   component={RouterLink}
    //     // />,
    //     // <MenuItem
    //     //   variant="contained"
    //     //   component={RouterLink}
    //     //   to={`/dashboard/manage-investor/request-invest/${params.row._id}`}
    //     //   onClick={handleClose}
    //     // >
    //     //   درخواست های سرمایه گذاری
    //     // </MenuItem>,
    //   ],
    // },
  ];
  const renderMenu = (investorId) => {
    return (
      <Menu
        id="basic-menu"
        anchorEl={openActionButton}
        open={openActionButton}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => handleOpenCredit(investorId)}>افزایش اعتبار</MenuItem>
        <MenuItem
          component={RouterLink}
          to={`/dashboard/manage-investor/detail/${investorId}`}
          onClick={handleClose}
        >
          ویرایش
        </MenuItem>
        <MenuItem onClick={handleOpenTicket}>ارسال تیکت</MenuItem>
        <MenuItem
          variant="contained"
          component={RouterLink}
          to={`/dashboard/manage-investor/request-invest/${investorId}`}
          onClick={handleClose}
        >
          درخواست های سرمایه گذاری
        </MenuItem>
      </Menu>
    );
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
      </GridToolbarContainer>
    );
  }
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - investors.length) : 0;

  const filteredInvestors = applySortFilter(
    investors,
    getComparator(order, orderBy),
    filterName,
    "phoneNumber"
  );

  const isInvestorsNotFound = filteredInvestors.length === 0;
  const MyCustomNoRowsOverlay = () => <p>---</p>;
  return (
    <Page title="مدیریت نظرات">
      <Container>
        <HeaderBreadcrumbs
          heading="مدیریت نظرات"
          links={[
            { name: "داشبورد", href: PATH_DASHBOARD.root },
            { name: "مدیریت نظرات", href: PATH_DASHBOARD.user.list },
          ]}
        />

        {loading ? (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <Card>
            <ManageInvestorListToolbar filterName={filterName} onFilterName={handleFilterByName} />

            <Scrollbar>
              <DataGrid
                autoHeight
                columns={columns}
                pageSizeOptions={[10, 25]}
                initialState={{
                  ...comments.initialState,
                  pagination: { paginationModel: { pageSize: 10 } },
                  columns: {
                    columnVisibilityModel: {
                      iban: false,
                      email: false,
                      // traderName: false,
                    },
                  },
                }}
                disableRowSelectionOnClick={true}
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                loading={loading}
                slots={{ toolbar: CustomToolbar }}
                rows={comments}
                getRowId={(row) => row._id}
              />
            </Scrollbar>

            <CreditChargeDialog
              open={openCredit}
              onClose={handleCloseCredit}
              onClick={handleSubmitCredit}
              invoices={invoices}
            />

            <TicketCreateDialog
              open={openTicket}
              onClose={handleCloseTicket}
              onClick={handleSubmitTicket}
            />
          </Card>
        )}
      </Container>
    </Page>
  );
}
